<script setup lang="ts">
  import {useStore} from 'vuex';
  import PageHeader from '@console/components/app/PageHeader.vue';
  import SitePane from '@console/components/app/SitePane.vue';
  import appApi from '@console/api/app.js';
  import LoginForm from '@console/components/LoginForm.vue';
  import {onMounted} from 'vue';
  import {useRoute} from 'vue-router';
  import type {LoginResponseData} from '@console/queries/auth';

  const route = useRoute();
  const store = useStore();

  onMounted(() => {
    if (route.query.activated) {
      store.dispatch('app/displayNotice', 'Email verified.');
    }
  });

  async function handleSuccess(data: LoginResponseData) {
    if (data?.user?.mfaSetupRequired) {
      // @TODO not really sure why router.push doesn't work here
      window.location.replace('/mfa/setup');
      return;
    }

    if (route.query.redirect) {
      window.location.replace(route.query.redirect as string);
    } else {
      if (appApi.getLastOrgSlug()) {
        appApi.saveTriggerAfterLogin(true);
      }

      window.location.replace(data.returnUrl);
    }
  }

  function handleError(error: any) {
    store.dispatch(
      'app/displayError',
      error?.response?.data?.message || 'Couldn’t sign in.'
    );
  }
</script>
<template>
  <site-pane>
    <page-header>
      <h1>Sign into Craft Console</h1>
    </page-header>

    <LoginForm @success="handleSuccess" @error="handleError" />

    <div class="mt-3 text-sm">
      <p>
        Don’t have an account yet?
        <span
          ><router-link
            :to="{
              path: '/register',
              query: {
                redirect: $route.query.redirect,
              },
            }"
            >Create an account</router-link
          >.</span
        >
      </p>
    </div>
  </site-pane>
</template>
